import { Routes } from '@angular/router';
import { OktaCallbackComponent } from '@okta/okta-angular';
import { authGuard, adminGuard } from './core/auth';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./pages/calculators/premix-calculator/premix-calculator.component').then(c => c.PremixCalculatorComponent),
    canActivate: [authGuard]
  },
  {
    path: 'login/callback',
    component: OktaCallbackComponent,
    canActivate: [authGuard]
  },
  {
    path: 'admin-home',
    loadComponent: () => import('./pages/admin/admin-premix/admin-premix.component').then(c => c.AdminPremixComponent),
    canActivate: [adminGuard]
  },
  {
    path: 'admin-add-edit-premix',
    loadComponent: () => import('./pages/admin/admin-premix/admin-add-edit-premix/admin-add-edit-premix.component').then(c => c.AdminAddEditPremixComponent),
    canActivate: [adminGuard]
  },
  {
    path: 'admin-add-edit-technical-guide',
    loadComponent: () => import('./pages/admin/admin-technical-guide/admin-add-edit-technical-guide/admin-add-edit-technical-guide.component').then(c => c.AdminAddEditTechnicalGuideComponent),
    canActivate: [adminGuard]
  }
];
